import React from "react";
import Styles from "./Styles.module.scss";
import classnames from "classnames";

declare interface LinkProps {
    className?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    noLineHeight?: boolean;
    disabled?: boolean;
    style?: React.CSSProperties;
    checked?: boolean;
}

const Link: React.FC<LinkProps> = (props) => {
    const {
        className,
        onClick,
        children,
        noLineHeight,
        checked,
        style,
        disabled,
        ...rest
    } = props;

    return (
        <button
            className={classnames(
                Styles.linkWidget,
                className,
                checked ? Styles.selected : ""
            )}
            style={noLineHeight ? { lineHeight: 0, ...style } : style}
            // onClick={onClick}
            onClick={(event) => {
                if (onClick) onClick(event);
                if (event.stopPropagation) event.stopPropagation();
            }}
            disabled={disabled}
            {...rest}
        >
            {children}
        </button>
    );
};

Link.defaultProps = {
    className: "",
    onClick: () => {},
    disabled: false,
    style: {},
};

export default Link;
